<template>
  <div class="project-container">
    <router-view name="Modal"></router-view>
    <div class="project-container-menu">
      <div class="project-title-container">
        <i class="el-icon-back" title="返回项目列表" @click="$router.push('/list?type=1')"></i>
        <h4>{{ $route.query.projectName }}</h4>
        <h5 style="color: #fff" v-if="projectDetail && projectDetail.farmArea">
          （面积：{{ projectDetail.farmArea }} km²）
        </h5>
      </div>
      <div class="project-item-list">
        <el-collapse value="1">
          <el-collapse-item title="方案列表" name="1">
            <el-checkbox-group v-model="checkPlanListIds">
              <div
                class="project-item-children-item disflex-item"
                v-for="planItem in planList"
                :key="planItem.planId"
                :class="{
                  'plan-active': planItem.planId == curPlanItem.planId,
                }"
              >
                <div
                  class="disflex-item-right"
                  @click="handlePlanCheckChange(planItem)"
                  style="display: flex;align-items: center;justify-content: center"
                >
                  <span @click.stop>
                    <el-checkbox :label="planItem.planId"> </el-checkbox>
                  </span>
                  <!--span style="display: inline-block; width: 20px;" @click.stop="handlePlanCheckChange(planItem)">
                    <img v-if="planItem.showCheck" src="../../asset/zy.png" style="width: 100%;height: 100%;vertical-align: top;">
                    <img v-else src="../../asset/by.png" style="width: 100%;height: 100%;vertical-align: top;">
                  </span-->
                  <span style="flex:1;">
                    <el-button type="text" v-if="!planItem.edit" :class="planItem.defaultFlag ? 'default-title' : 'title'">{{
                      planItem.planName
                    }}</el-button>
                    <span v-else @click.stop.prevent @focus.stop.prevent>
                      <el-input
                        v-model="planItem.inputName"
                        :ref="`plan_${planItem.planId}`"
                        style="width: 200px"
                        @keydown.enter.native="changeTitle(planItem)"
                      />
                    </span>
                  </span>
                  <span style="float: right">
                    <div v-show="planItem.edit" @click.stop>
                      <el-button type="text" @click.stop="changeTitle(planItem)"
                        >确定</el-button
                      >
                      <el-button type="text" @click.stop="planItem.edit = false"
                        >取消</el-button
                      >
                    </div>
<!--                    :disabled="planItem.economicStatus != 1"-->
                    <div v-show="!planItem.edit" @click.stop>
                      <el-button
                        type="text"
                        @click.stop.prevent="generateReport(planItem)"
                        :disabled="planItem.economicStatus != 1"
                      >报告</el-button>
                      <!--el-button
                        type="text"
                        @click.stop="handleSetDefaultPlan(planItem)"
                        v-if="planItem.defaultFlag == 0"
                        >默认</el-button
                      -->
                      <el-button type="text" @click.stop="editName(planItem,'plan_'+planItem.planId)"
                        >修改</el-button
                      >
                      <el-button
                        type="text"
                        :disabled="planItem.defaultFlag == 1"
                        @click.stop="deletePlanList(planItem)"
                        >删除</el-button
                      >
                    </div>
                  </span>
                </div>
              </div>
            </el-checkbox-group>
            <div class="project-item-btn-group">
              <div class="project-item-btn-item">
                <span
                  v-if="planList.length > 0"
                  @click="
                    () => {
                      this.planModalVisible = true;
                      this.curPlan = {};
                    }
                  "
                  >创建方案</span
                >

                <el-dropdown @command="handleWindFarmBoundary">
                  <div class="operate-item">
                    <i class="operate-item-icon resource-icon"></i>
                    <span>风场范围 <i class="el-icon-arrow-down"></i></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="drawWindFarm"
                      >手绘范围</el-dropdown-item
                    >
                    <el-dropdown-item command="importKMZ"
                      >导入KMZ</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="exportKMZ"
                      :disabled="!showWindfarm"
                      >导出KMZ</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <span
                  :class="[
                    'farm-area-button',
                    {
                      'is-active': toolUIStatus.newFarm
                    }
                  ]"
                  @click="handleNewWindFarm()"
                  >{{ showWindfarm ? '重绘风场' : '风场范围' }}</span
                > -->

                <span v-if="checkPlanListIds.length > 1" @click="contrastClick"
                  >方案对比</span
                >
                <span v-else class="disabled"
                  >方案对比</span
                >
                <!--span @click="exportReport">下载报告</span>
                <DownloadReports
                  :projectId="$route.query.projectId"
                  :type="1"
                  v-if="planList.length > 0"
                />
                <span class="disabled">下载报告</span-->
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="project-item-list">
        <el-collapse value="2">
          <el-collapse-item title="资源列表" name="2">
            <div
              class="project-item-children-item disflex-item"
              v-for="item in itemList"
              :key="item.itemId"
              :class="{ 'plan-active': currentItem.itemId === item.itemId }"
            >
              <div
                class="disflex-item-right"
                @click="handleItemPointClick1(item)"
              >
<!--                <span @click.stop>-->
<!--                  <el-checkbox-->
<!--                    :label="item.itemId"-->
<!--                    v-model="item.showCheck"-->
<!--                    @change="checkboxChange(item)"-->
<!--                  >-->
<!--                  </el-checkbox>-->
<!--                </span>-->
                  <span style="display: inline-block; width: 20px;" @click.stop="checkBoxChangeByEye(item)">
                    <img v-if="item.showCheck" src="../../asset/zy.png" style="width: 100%;height: 100%;vertical-align: top;">
                    <img v-else src="../../asset/by.png" style="width: 100%;height: 100%;vertical-align: top;">
                  </span>
                <el-button type="text" v-if="!item.edit" :class="item.isdefault == 1 || item.istypical == 1 ? 'default-title' : 'title'">{{
                  (item.itemType == '1' ? '点：' : '面：') + item.itemName
                }}</el-button>
                <span v-else @click.stop.prevent @focus.stop.prevent>
                  <el-input
                    v-model="item.inputItemName"
                    :ref="`item_${item.itemId}`"
                    style="width: 200px"
                    @keydown.enter.native="confirmChangeItemName(item)"
                  />
                </span>
                <span style="float: right">
                  <div v-show="item.edit" @click.stop>
                    <el-button
                      type="text"
                      @click.stop="confirmChangeItemName(item)"
                      >确定</el-button
                    >
                    <el-button type="text" @click.stop="item.edit = false"
                      >取消</el-button
                    >
                  </div>
                  <div v-show="!item.edit" @click.stop>
                    <el-button
                      type="text"
                      @click.stop="handleSetTypicalItem(item)"
                      v-if="item.istypical == 0 && item.itemType == '1'"
                      >设代表点</el-button
                    >
                    <el-button
                      type="text"
                      :disabled="item.isdefault == 1"
                      @click.stop.prevent="editName(item,'item_'+item.itemId)"
                      >修改</el-button
                    >
                    <el-button
                      :disabled="item.isdefault == 1 || item.istypical == 1"
                      type="text"
                      @click.stop.prevent="deleteWindItem(item)"
                      >删除</el-button
                    >
                  </div>
                </span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="project-item-list">
        <el-collapse value="3">
          <el-collapse-item title="敏感因素" name="3">
            <div
              class="project-item-children-item disflex-item"
              v-for="item in windfarmExclusiveList"
              :key="item.exclusiveId"
              :class="{
                'plan-active':
                  curWindExclusiveItem.exclusiveId === item.exclusiveId,
              }"
            >
              <div
                class="disflex-item-right"
                @click="handleExclusiveClick(item)"
              >
<!--                <span @click.stop>-->
<!--                  <el-checkbox-->
<!--                    :label="item.exclusiveId"-->
<!--                    v-model="item.showCheck"-->
<!--                  >-->
<!--                  </el-checkbox>-->
<!--                </span>-->
                  <span style="display: inline-block; width: 20px;" @click.stop="checkExclusiveChange(item)">
                    <img v-if="item.showCheck" src="../../asset/zy.png" style="width: 100%;height: 100%;vertical-align: top;">
                    <img v-else src="../../asset/by.png" style="width: 100%;height: 100%;vertical-align: top;">
                  </span>
<!--                <el-button type="text" v-if="!item.edit" class="title">{{-->
<!--                  item.exclusiveName-->
<!--                }}</el-button>-->
                <span style="display: inline-block;">
                <el-tooltip effect="dark" :content="item.exclusiveName" placement="top" v-if="!item.edit">
                  <a style="color:#ffffff;width: 120px;font-size: 14px;padding-top:5px;display: inline-block">{{item.exclusiveName.substring(0, 6)}}</a>
                </el-tooltip>
                <span v-else @click.stop.prevent @focus.stop.prevent>
                  <el-input
                          v-model="item.inputName"
                          style="width: 200px"
                          :ref="`exclus_${item.exclusiveId}`"
                          @keydown.enter.native="confirmChangeExclusiveName(item)"
                  />
                </span>
                <el-tooltip effect="dark" :content="item.exclusiveTypeName" placement="top"  v-if="!item.edit">
                  <a style="color:#ffffff;font-size: 14px;padding-top:5px;display: inline-block">{{item.exclusiveTypeName.substring(0, 6)}}</a>
                </el-tooltip>
                </span>
                <span style="float: right">
                  <template v-if="item.edit">
                    <el-button
                      type="text"
                      @click.stop="confirmChangeExclusiveName(item)"
                      >确定</el-button
                    >
                    <el-button type="text" @click.stop="item.edit = false"
                      >取消</el-button
                    >
                  </template>
                  <template v-else>
                    <el-button
                      type="text"
                      @click.stop.prevent="exportExclusiveKMZ(item)"
                    >导出</el-button>
                    <el-button
                      type="text"
                      @click.stop.prevent="editName(item,'exclus_'+item.exclusiveId)"
                      >修改</el-button>
                    <el-button
                      type="text"
                      @click.stop.prevent="deleteExclusiveItem(item)"
                      >删除</el-button>
                  </template>
                </span>
              </div>
            </div>
            <div class="project-item-btn-group">
              <div class="project-item-btn-item">
                <span
                  :class="[
                    'farm-area-button',
                    {
                      'is-active': toolUIStatus.exclusive,
                    },
                  ]"
                  @click="handleToolClick('exclusive')"
                  >手绘</span
                >
                <span @click="exclusiveModalVisible = true">导入</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <leaflet-map
      ref="l"
      v-model="mapData"
      :toolbar="toolbar"
      :toolbarStatus="toolbarStatus"
      v-on:update:toolbarStatus="handleTriggerTools"
      :layers="layers"
      @create="createEleFn"
      :getStyle="getStyle"
      :drawOptions="drawOptions"
      @click="handleElementClick"
      @edit="handleMapInput"
    />
    <PointDetail
      fromProjectList
      :title="'点资源：' + (activePointItem.itemName || '临时点')"
      v-if="activePointItem"
      :itemConfig.sync="activePointItem"
      @del="handleDelPointItemClick"
      @saveList="handleSavePointClick"
      @handleCloseModalClick="handleCloseModalClick"
    />
    <PointDetail
      className="tower-detail-point"
      fromProjectList
      :title="'测风塔：' + curTower.towerNo"
      v-if="activeSpecialPointItem"
      :showBottomArea="false"
      :itemConfig.sync="activeSpecialPointItem"
      @del="handleDelPointItemClick"
      @saveList="handleSavePointClick"
      @handleCloseModalClick="activeSpecialPointItem = null"
    />
    <FaceItem
      ref="face"
      v-if="activeFaceItem"
      :title="'区域资源：' + (activeFaceItem.itemName || '临时区域')"
      :itemConfig.sync="activeFaceItem"
      @updateImg="updateMapItemsIMG"
      @addItem="addFaceItem"
      @deleteItem="deleteFaceItem"
      @handleCloseModalClick="handleCloseModalClick"
    />
    <Tool
      @mapToolClick="handleToolClick"
      @newWindFarm="handleNewWindFarm"
      @importFile="handleImportFile"
      :UIStatus="toolUIStatus"
    />
    <downPlanReportModal
        :plan="reportPlan"
        :visible="downPlanReportVisible"
        @save="downReport"
        @close="closeDownPlanReportModal">
    </downPlanReportModal>
    <ChangePlanNameModal
      :visible="planModalVisible"
      :plan="curPlan"
      v-if="planModalVisible"
      @saveBack="getPlanList"
      @close="planModalVisible = false"
    />
    <ChangeWindNameModal
      :visible="windModalVisible"
      :item="curWindItem"
      v-if="windModalVisible"
      @saveBack="getWindResource"
      @close="windModalVisible = false"
    />
    <uploadBoundaryModal
      :visible="boundaryImportVisible"
      @close="closeBoundaryModal"
      @uploadConfirm="handleBoundarySuccessUpload"
    />
    <ChangeWindExclusiveModal
      :visible="windExclusiveModalVisible"
      :item="curWindExclusiveItem"
      v-if="windExclusiveModalVisible"
      :geometryInfo="createForm.geometryInfo"
      @close="handleWindExclusiveClose"
    />
    <ExclusiveUploadModal
      :visible="exclusiveModalVisible"
      @close="exclusiveModalVisible = false"
      @uploadConfirm="handleExcluseSiveSuccess"
    >
    </ExclusiveUploadModal>
<!--    <LayoutUploadModal-->
<!--      :visible="layoutModalVisible"-->
<!--      @close="layoutModalVisible = false"-->
<!--      @uploadConfirm="handleLayoutSuccess"-->
<!--    >-->
<!--    </LayoutUploadModal>-->
    <!-- 城市搜索 -->
    <CityLocationSearch
      v-if="citySearchVisible"
      @close="
        () => {
          this.citySearchVisible = false;
          this.activeFaceItem = null;
        }
      "
      :regionList="regionList"
      @clearPolygonItem="activeFaceItem = null"
    />
    <!-- 经纬度搜索 -->
    <LanlonSearch
      v-if="lanlonSearchVisible"
      @close="lanlonSearchVisible = false"
    />
    <!-- 方案工具栏 -->
    <PlanTool
      :id="curPlanItem.planId"
      @showClick="handleWindFarmItemClick"
      v-if="isPlanToolShow"
      :plan="curPlanItem"
    />
    <!-- 对比弹窗 -->
    <CompareTable
      :planTableData="tableContrastData"
      :tableOptimalIndex="tableOptimalIndex"
      :isShowContrast="showWindContrastDialog"
      @closeClick="showWindContrastDialog = false"
    ></CompareTable>
    <FanPanel
      :turbine="curFan"
      scene="plan"
      :title="'风机：' + curFan.turbineNo + '（轮毂：' + curFan.height + 'm）'"
      v-if="fanPanelVisible"
      @close="fanPanelVisible = false"
      :turbineList="turbineList"
      :plan="curPlanItem"
    ></FanPanel>
  </div>
</template>
<script>
function getMap(array, id) {
  if (!array.length) return array;

  if (Array.isArray(array) && typeof array[0] === 'number') {
    array[0] = {
      id,
      lat: array[1],
      lng: array[0],
    };

    array.length = 1;
    return 'change';
    // Reflect.deleteProperty(array, '1');
  } else {
    for (let i = 0; i < array.length; i++) {
      let flag = getMap(array[i], id);

      if (flag === 'change') {
        array[i] = array[i][0];
      }
    }
  }
}

import L from 'leaflet';
import { getToken } from '@/utils';
import FanPanel from './components/fan-panel.vue';
import Tool from './components/tools';
import loadingMask from '@/components/loading-mask';
import ExclusiveUploadModal from './components/exclusiveUploadDialog.vue';
import LayoutUploadModal from './components/layoutUploadDialog.vue';
// import FaceDetail from './project-detail/components/face-item';
import PointDetail from './components/point-detail';
import ChangePlanNameModal from './components/changePlanNameModal.vue';
import downPlanReportModal from './components/downPlanReportModal.vue';
import ChangeWindNameModal from './components/changeWindNameModal.vue';
import ChangeWindExclusiveModal from './components/changeWindExclusiveModal.vue';
import uploadBoundaryModal from './components/upload-boundary-modal.vue';
import LanlonSearch from './components/lanlonSearch.vue';
import CityLocationSearch from './components/city-location-search.vue';
import FaceItem from './components/face-item.vue';
// import Map from '../map';
import PlanTool from './components/plan-tools.vue';
import CompareTable from './components/compare-table.vue';
import {
  parseMapDataToGeoInfo,
  calcAreaByData,
  toFixed,
  // findDeepId,
  isObject,
  findDeepByAttr,
  eventBus,
  parseGeoInfoToMapData,
  calcAverage,
} from './utils';
import { mapGetters, mapState } from 'vuex';
import flattenDepth from 'lodash/flattenDepth';
import cloneDeep from 'lodash/cloneDeep';
import turbineIcon from '@/asset/windfarm/turbine.png';
import turbineIconSelect from '@/asset/windfarm/turbine-select.png';
import towerIcon from '@/asset/windfarm/tower.png';
import towerIconSelect from '@/asset/windfarm/tower-select.png';
import { FACEITEMAREALIMIT, WINDFARMAREALIMIT } from './utils/constant';
import {
  getUserItemList,
  refreshWindfarmPlanList,
  deleteWindfarmPlan,
  deleteWindItem,
  getWindfarmExclusive,
  deleteWindfarmExclusive,
  createStation,
  queryProjectInfo,
  getTowerByPlanId,
  getTurbineList,
  updateItemChecked,
  updatePlanName,
  updateItemName,
  updateExclusiveName,
  setDefaultPlan,
  setTypicalItem
} from './service';
import to from 'await-to-js';
// import { Pop } from '@/utils';
// import Vue from 'vue';


// let currentVue = null;
let currentP = null;
// let currentMap = null;
const COLORS = [
  '#91ca8c',
  '#ffaf51',
  '#ffee51',
  '#8c6ac4',
  '#715c87',
  '#e69d87',
  '#8dc1a9',
  '#ea7e53',
  '#eedd78',
  '#73a373',
  '#73b9bc',
];

export default {
  components: {
    Tool,
    FanPanel,
    // FaceDetail,
    PointDetail,
    ChangePlanNameModal,
    ChangeWindNameModal,
    LanlonSearch,
    CityLocationSearch,
    PlanTool,
    uploadBoundaryModal,
    CompareTable,
    ChangeWindExclusiveModal,
    FaceItem,
    ExclusiveUploadModal,
    LayoutUploadModal,
    downPlanReportModal
  },
  data() {
    return {
      turbineList: [],
      exclusiveModalVisible: false,
      layoutModalVisible: false,
      boundaryImportVisible: false,
      towerIcon,
      towerIconSelect,
      turbineIcon,
      turbineIconSelect,
      showWindfarm: false,
      activeFaceItem: null,
      activePointItem: null,
      activeSpecialPointItem: null,
      currentFaceItem: null,
      projectDetail: null,
      uploadrules: {
        uploadFileName: [
          { required: true, message: '请上传风场/风机文件', trigger: 'change' },
        ],
        windfarmName: [
          { required: true, message: '请填写风场名称', trigger: 'change' },
          {
            required: true,
            message: '风场名称不超过30个字符',
            trigger: 'change',
            max: 30,
          },
        ],
      },
      fileList: [],
      uploadForm: {
        windfarmName: '',
        uploadFileName: '',
      },
      showImportWindFarmDialog: false,
      showWindFarmCreateDialog: false,
      action: `${process.env.VUE_APP_API_HOST}/windfarm/windfarm/uploadWindFarmPointFile`,
      toolbar: {
        drawCircleMarker: false,
        drawPolyline: false,
        drawRectangle: false,
        drawPolygon: false,
        editMode: false,
        removalMode: false,
        dragMode: false,
      },
      createForm: {
        windfarmName: '',
        geometryInfo: '',
      },
      // 地图编辑按钮状态控制
      layers: [],
      currentEles: {
        polygons: [],
        points: [],
      },
      file: null,
      checkList: [],
      windList: [], // 风资源列表，
      planList: [], // 方案列表
      itemList: [], // 风资源列表
      planModalVisible: false,
      curPlan: {},
      curWindItem: {},
      // resourcesList: [],
      windModalVisible: false,
      lanlonSearchVisible: false,
      citySearchVisible: false,
      checkPlanList: [],
      isPlanToolShow: false,
      curPlanItem: {},
      currentItem: {},
      checkIqtemList: [],
      checkPlanListIds: [],
      tableContrastData: [],
      tableOptimalIndex: -1,
      showWindContrastDialog: false,
      curFan: {},
      curTower: {},
      windfarmExclusiveList: [],
      windExclusiveModalVisible: false,
      curWindExclusiveItem: {},
      windFarmData: [],
      fanPanelVisible: false,
      downPlanReportVisible: false,
      reportPlan: null
      // cityS
    };
  },
  beforeDestroy() {
    this.$store.commit('WindFarm/CLEAN_MAP');
    this.$bus.$off('getMapInstance', this.getMapInstance);
    this.$bus.$off('clearUnloginData', this.clearMapData);
    this.$bus.$off('save-point-item-click', this.handleSavePointItemClick);
    this.$bus.$off('create-point-list', this.createInProjectList);
    this.$bus.$off('create-polygon-item', this.handleCreateArea);
    this.$bus.$off('createLimitAdd', this.addExclusive);
    this.$bus.$off('updateTowerList', this.updateTower);
    this.$bus.$off('updateTurList', this.updateTurbine);
    this.$bus.$off('resultClickFj', this.resultFj);
    this.$bus.$off('showTurbineDetail', this.showFengjiDetail);
    this.$bus.$off('showTowerDetail', this.showTower);
    this.$bus.$off('updatePlanToolIconStatus', this.updatePlanToolIconStatus)

    eventBus.$off('getMapInstance', this.getMapInstance);
  },
  async created() {
    this.$store.dispatch('WindFarm/getDataSet');
    this.$bus.$on('getMapInstance', this.getMapInstance);
    this.$bus.$on('clearUnloginData', this.clearMapData);
    // 保存风资源
    this.$bus.$on('save-point-item-click', this.handleSavePointItemClick);
    // 创建点
    this.$bus.$on('create-point-list', this.createInProjectList);
    this.$bus.$on('updateWindFarmAndItems', this.updateWindFarmReducer);
    // 点击城市创建区域
    this.$bus.$on('create-polygon-item', this.handleCreateArea);

    this.$bus.$on('createLimitAdd', this.addExclusive);
    this.$bus.$on('updateTowerList', this.updateTower);
    this.$bus.$on('updateTurList', this.updateTurbine);
    this.$bus.$on('resultClickFj', this.resultFj);
    this.$bus.$on('showTurbineDetail', this.showFengjiDetail);
    this.$bus.$on('showTowerDetail', this.showTower);

    this.$bus.$on('getTowersCircle', this.getTowerCircle);
    this.$bus.$on('showTowersCircle', this.setTowerCircle);
    this.$bus.$on('clearTowersCircle', this.clearTowersCircle);

    this.$bus.$on('updatePlanToolIconStatus', this.updatePlanToolIconStatus);

    eventBus.$on('getMapInstance', this.getMapInstance);

    this.queryProjectDetail();
    this.getPlanList();
  },

  async mounted() {

    await this.getWindResource({
      isCreate: true,
    });

    this.updateResource();

    this.getWindfarmExclusiveList();
    this.$store.dispatch('getRegionList');

    this.$nextTick(() => {
      const currentXz = this.itemList.find(i => i.isdefault == 1);

      if (currentXz) {
        this.handleItemPointClick(currentXz, 11);
        this.activeFaceItem = currentXz;
      }
    });
  },

  computed: {
    ...mapState(['rawRegionList']),
    ...mapGetters(['regionList']),
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'drawOptions',
      'windFarmIsEdit',
      'windfarmWireList',
    ]),
    ...mapState('WindFarm', ['toolbarStatus']),
    mapData: {
      get() {
        return this.$store.state.WindFarm.mapData;
      },
      set(val) {
        this.$store.state.WindFarm.mapData = { ...val };
      },
    },
    extraData() {
      return {
        apiKey: getToken(),
        projectId: this.$route.query.projectId,
        windfarmName: this.uploadForm.windfarmName,
      };
    },
    // checkIqtemList() {
    //   return this.resourcesList.map((v) => v.itemId);
    // },
    // checkPlanListIds() {
    //   return this.checkPlanList.map((v) => v.planId);
    // },
    // curPlanId() {
    //   return this.checkPlanListIds?.[this.checkPlanListIds.length - 1];
    // },
  },
  watch: {
    $route: {
      handler() {
        this.activeFaceItem = null;
        this.activePointItem = null;
        const { name = '' } = this.$route;

        const { planId } = this.$route.query;

        if (
          ['tower', 'deploy', 'power', 'economic-evaluation'].includes(name) ||
          !!planId
        ) {
          this.isPlanToolShow = true;
        } else {
          this.isPlanToolShow = false;
        }
        if(name == 'tower'){
          this.getTowerCircle();
        }else{
          this.$refs.l.drawCircle([]);
        }
      },
      deep: true,
      immediate: true,
    },
    windfarmExclusiveList: {
      handler() {
        this.updateExclusiveArea();
      },
      deep: true,
    },
  },
  methods: {
    editName(item,id){
      item.edit = true;
      this.$nextTick(function(){
        const dom = this.$refs[id][0];
        dom.focus();
        dom.select();
      });

    },
    updatePlanToolIconStatus() {
      this.getPlanList()
    },
    focusToWindFarm() {
      let data = this.windFarmData[0];
      if ((JSON.parse(this.projectDetail.data.projectInfo.geometryInfo)).type == 'MultiPolygon') {
        data = this.windFarmData[0][0];
      }
      if (!data) return;
      let aver1 = data.map(i => i.lat);
      let aver2 = data.map(i => i.lng);

      const loc = {
        lat: calcAverage(aver1),
        lng: calcAverage(aver2),
      };
      this.$refs.l.map.setView(loc);
    },
    handleExcluseSiveSuccess() {
      this.exclusiveModalVisible = false;
      this.handleWindExclusiveClose();
    },
    handleLayoutSuccess() {
      this.layoutModalVisible = false;
      //参照deploy.vue中自动排布按钮的事件响应，在deploy组件中显示排布结果
    },
    async changeTitle(planItem) {
      const [err] = await to(
        updatePlanName({
          planId: planItem?.planId,
          planName: planItem.inputName,
          projectId: this.$route.query.projectId,
        })
      );
      if (!err) {
        planItem.edit = false;
        this.getPlanList();
      }
    },
    handleSetDefaultPlan(plan) {
      this.$confirm(`是否设置【${plan.planName}】为默认方案？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await to(
          setDefaultPlan({
            planId: plan.planId,
            projectId: this.$route.query.projectId,
          })
        );
        if (!err) {
          this.getPlanList();
        }
      });
    },
    handleSetTypicalItem(item) {
      this.$confirm(`是否设置【${item.itemName}】为代表点？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await to(
          setTypicalItem({
            itemId: item.itemId,
            projectId: this.$route.query.projectId,
          })
        );
        if (!err) {
          this.getWindResource();
        }
      });
    },
    checkboxChange(item) {
      updateItemChecked({
        ischecked: item.showCheck ? 1 : 0,
        itemId: item.itemId,
      }).then(() => {
        this.updateResource();
      });
    },
    async checkBoxChangeByEye(item,zoom){
      item.showCheck = !item.showCheck;
      await updateItemChecked({
        ischecked: item.showCheck ? 1 : 0,
        itemId: item.itemId,
      });
      await this.updateResource();
      if(item.showCheck){
        //this.currentItem = item;
        this.showItemById(item.itemId, item.itemType, false, zoom);
      }else{
        if(item.itemType == 1){
          if(item.itemId == this.currentItem.itemId){
            this.activePointItem = null;
          }
        }else{
          if(item.itemId == this.activeFaceItem.itemId){
            this.activeFaceItem = null;
          }
        }
      }
    },
    addFaceItem() {
      const { data, adcode, itemName, geometryInfo, itemType, id,area } =
        this.activeFaceItem;

      let newData = data;
      // if (itemType == 2) {
      //   newData = data[0][0];
      // }

      this.createPolygonItem(newData, itemType, adcode, {
        geometryInfo: geometryInfo,
        name: itemName,
        area,
        needTrans: false,
        setView: true,
        id,
      });
      //
      // this.createPolygonItem(this.activeFaceItem );
    },
    generateReport(item){
      this.downPlanReportVisible = true;
      this.reportPlan = item;
    },
    downReport(data){
      const apiKey = getToken();
      const loading = this.$loading({
        text: '正在导出报告，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
    // &planId=${item.planId}
      this.$fetch(`/windfarm/report/generateReport?apiKey=${apiKey}&projectId=${this.$route.query.projectId}&`+data.params, {
        method: 'post',
        showError: true,
        noJudge: true,
        responseType: 'blob',
      })
              .then(res => {
                if(res.status == 401){
                  loading.close();
                  this.errorMessage(res.data);
                  return;
                }
                const blob = new Blob([res.data]);
                var link = document.createElement('a');
                var fileURL = URL.createObjectURL(blob);
                link.target = '_blank';
                link.href = fileURL;
                let docName = this.$route.query.projectName+"-"+data.data.planName + "-宏观选址报告.docx";
                link.download = docName; //文件名称
                link.click();
                loading.close();

              })
              .catch(() => {});
    },
    closeDownPlanReportModal(){
      this.downPlanReportVisible = false;
      this.reportPlan = null;
    },
    async errorMessage(data){
      const text = await data.text(); // 将 Blob 转为文本
      this.$message.error(text);
    },
    deleteFaceItem() {
      const { id } = this.activeFaceItem;
      this.$confirm('是否删除该区域', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const index = this.currentEles.polygons.findIndex(i => i.id == id);
        const item = this.currentEles.polygons[index];
        this.currentEles.polygons.splice(index, 1);

        if (!item.isTemp) {
          this.deleteWindItem(this.activeFaceItem, true);
        } else {
          this.updateResource();
        }

        this.activeFaceItem = null;
      });
    },
    async getActivePlanByQuery(params) {
      let cu = null;
      if(params.isNewWindFarm && params.planId){
        cu = params.planId;
        this.curPlanItem = this.planList.find((j) => j.planId == cu) || {};
        this.curPlanItem.showCheck = true;
        this.handlePlanCheckChange(this.curPlanItem);
        return;
      }else{
        const { planId } = this.$route.query;
        cu = planId;
      }


      if (cu) {
        this.curPlanItem = this.planList.find((j) => j.planId == cu) || {};
        this.updateTower(cu);
        this.updateTurbine(cu);
      }
    },
    async handleBoundarySuccessUpload() {
      this.$fetch('/windfarm/station/refreshWindfarmPlanList', {
        showError: true,
        params: {
          projectId: this.$route.query.projectId,
        },
      }).then((result) => {
        this.planList = (result.data?.planList || []).map((v) => {
          return {
            inputName: v.planName,
            ...v,
            edit: false,
            showCheck: false
          };
        });
        this.planList[0].showCheck = true;
        this.curPlanItem = this.planList[0] || {};
        this.$router.replace({
          name: 'project-list',
          query: {
            planId: this.curPlanItem.planId,
            projectId: this.$route.query.projectId,
            projectName: this.$route.query.projectName,
          },
        });
      });
      this.boundaryImportVisible = false;
      this.queryProjectDetail();
      await this.getWindResource();
      this.updateResource();
    },
    async closeBoundaryModal() {
      this.boundaryImportVisible = false;
    },
    async handleWindExclusiveClose() {
      this.windExclusiveModalVisible = false;
      this.toolUIStatus.exclusive = false;
      await this.getWindfarmExclusiveList();
      await this.updateExclusiveArea();
    },
    updateTurbine(planId = this.$route.query.planId, clear) {
      if (clear) {
        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'turList',
          data: [],
        });
        return;
      }
      getTurbineList(planId).then((res) => {
        const { data } = res;
        const { turbineList } = data;

        const buildIconDiv = (title,turbineId) => {
          return L.divIcon({
            iconSize: [25, 25],
            iconAnchor: [13, 42],
            className: 'div-icon-markers-fengji',
            html: `<div class="wrapper">
            <div class="title">#${title}</div>
            <img src="${turbineId === this.curFan.turbineId ? turbineIconSelect : turbineIcon}" alt=""/></div>`,
          });
        };

        this.turbineList = turbineList;

        const turbineArr = turbineList.map(i => {
          return {
            id: i.turbineId,
            icon: buildIconDiv(i.turbineNo,i.turbineId),
            lat: i.lat,
            lng: i.lon,
          };
        });

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'turList',
          data: turbineArr,
        });

        this.queryProjectDetail(false);
      });
    },

    editTurbine(turbine, edit) {
        const buildIconDiv = (title,turbineId) => {
          return L.divIcon({
            iconSize: [25, 25],
            iconAnchor: [13, 42],
            className: 'div-icon-markers-fengji',
            html: `<div class="wrapper">
            <div class="title">#${title}</div>
            <img src="${turbineId === this.curFan.turbineId ? turbineIconSelect : turbineIcon}" alt=""/></div>`,
          });
        };

        const turbineArr = this.turbineList.map(i => {
          return {
            id: i.turbineId,
            icon: buildIconDiv(i.turbineNo,i.turbineId),
            lat: i.lat,
            lng: i.lon,
          };
        });

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'turList',
          data: turbineArr,
        });

        //编辑状态
          this.$bus.$emit('getMapInstance', (mapInstance) => {
            mapInstance.shapes.markers.forEach((item)=>{
                //执行代码
                if(item.__data.id == this.curFan.turbineId  && edit){
                    item.pm.enableLayerDrag();
                    item.on('dragstart', this.dragStart);
                    item.on('dragend', this.dragEnd);
                }else{
                  item.pm.disableLayerDrag();
                }
            });
          });
    },

    editTower(tower, edit) {
        const buildIconDiv = (title,towerId) => {
          return L.divIcon({
            iconSize: [25, 25],
            iconAnchor: [13, 42],
            className: 'div-icon-markers-fengji',
            html: `<div class="wrapper">
            <div class="title">#${title}</div>
            <img src="${towerId === this.curTower.towerId ? towerIconSelect : towerIcon}" alt=""/></div>`,
          });
        };

        const towerArr = this.towerList.map(i => {
          return {
            id: i.towerId,
            icon: buildIconDiv(i.towerNo,i.towerId),
            lat: i.lat,
            lng: i.lon,
          };
        });

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'tower',
          data: towerArr,
        });

        //编辑状态
        if(edit){
          this.$bus.$emit('getMapInstance', (mapInstance) => {
            mapInstance.shapes.markers.forEach((item)=>{
                //执行代码
                if(item.__data.id == this.curTower.towerId){
                    item.pm.enableLayerDrag();
                    item.on('dragstart', this.dragStart);
                    item.on('dragend', this.dragEnd);
                }
            });
          });
        }
    },

    dragStart(e) {
      const data = e?.target?.__data;
      //eventBus.$emit('dragStartFj', data);
    },

    dragEnd(e) {
      let data = e.target.__data;
      data.lat = e.target.getLatLng().lat.toFixed(6);
      data.lng = e.target.getLatLng().lng.toFixed(6);
      if(data.type === 'turList'){
        this.$bus.$emit('updateTurbineLocation', data);
      }else if(data.type === 'tower'){
        this.$bus.$emit('updateTowerLocation', data);
      }
    },

    updateTower(planId = this.$route.query.planId, clear = false) {
      if (clear) {
        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'tower',
          data: [],
        });
        return;
      }

      getTowerByPlanId(planId).then((res) => {
        const { data } = res;
        const { towerList } = data;

        const iconDiv = (title,towerId) => {
          return L.divIcon({
            iconSize: [25, 25],
            iconAnchor: [13, 42],
            className: 'div-icon-markers-fengji',
            html: `<div class="wrapper">
              <div class="title">#${title}</div>
              <img src="${towerId === this.curTower.towerId ? towerIconSelect : towerIcon}" alt=""/></div>`,
          })
        };

        this.towerList = towerList;

        const towerArr = towerList.map(i => {
          return {
            id: i.towerId,
            icon: iconDiv(i.towerNo,i.towerId),
            lat: i.lat,
            lng: i.lon,
          };
        });

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'tower',
          data: towerArr,
        });
      });
    },
    queryProjectDetail(view = true) {
      queryProjectInfo(this.$route.query.projectId).then((res) => {
        this.projectDetail = res;

        if (!this.projectDetail.data.projectInfo.geometryInfo) {
          return;
        }

        this.showWindfarm = true;

        const mapData = parseGeoInfoToMapData(
          this.projectDetail.data.projectInfo.geometryInfo
        );

        this.windFarmData = mapData;

        this.updateWindFarm(mapData);

        const loc = {
          lat: this.projectDetail.data.projectInfo.lat,
          lng: this.projectDetail.data.projectInfo.lon,
        };

        if(view)
          this.$refs.l.map.setView(loc, 12);
      });
    },

    updateWindFarm(polygons) {
      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'windFarm',
        data: polygons,
      });
    },

    getTowerCircle(planId = this.$route.query.planId) {

      getTowerByPlanId(planId).then((res) => {
        const { data } = res;
        const { towerList,param } = data;
        const towerArr = towerList.map(i => {
          return L.circle([i.lat,i.lon],{
            weight: 2,
            color: "#fdf333",
            fillColor: "#fdf333",
            fillOpacity: 0,
            radius: param[0].typicalRadius
          });
        });

        this.$refs.l.drawCircle(towerArr);
      });
    },
    setTowerCircle(data){
      const towerArr = data.towerList.map(i => {
        return L.circle([i.lat,i.lon],{
          weight: 2,
          color: "#fdf333",
          fillColor: "#fdf333",
          fillOpacity: 0,
          radius: data.param[0].typicalRadius
        });
      });

      this.$refs.l.drawCircle(towerArr);
    },
    clearTowersCircle(){
      this.$refs.l.drawCircle([]);
    },

    editWindItemModal(item) {
      this.curWindItem = item;
      this.windModalVisible = true;
    },
    editPlanModal(plan) {
      this.curPlan = plan;
      this.planModalVisible = true;
    },
    editExclusiveModal(exclusive) {
      this.curWindExclusiveItem = exclusive;
      this.windExclusiveModalVisible = true;
    },
    clearMapData() {
      this.currentEles = {
        polygons: [],
        points: [],
      };
    },
    async getWindResource() {
      const [err, result] = await to(
        getUserItemList({
          projectId: this.$route.query.projectId,
        })
      );
      if (!err) {
        if (!result?.data?.itemList) {
          this.itemList = [];
        } else {
          this.itemList =
            result?.data?.itemList.map(i => {
              if (i.itemType == 1) {
                const arr = JSON.parse(i.geometryInfo).coordinates;

                return {
                  ...i,
                  lon: arr[0],
                  lat: arr[1],
                  lng: arr[0],
                  showCheck: i.ischecked !== 0,
                  inputItemName: i.itemName,
                  edit: false,
                };
              } else {
                return {
                  ...i,
                  showCheck: i.ischecked !== 0,
                  inputItemName: i.itemName,
                  edit: false,
                };
              }
            }) || [];
        }
      }
    },

    async updateResource(arr = []) {
      this.currentEles.points = this.itemList
        .filter(i => i.itemType == 1)
        .filter(i => i.showCheck)
        .map(i => {
          return {
            ...i,
            id: i.itemId,
            data: {
              lon: i.lon,
              lat: i.lat,
              id: i.itemId,
            },
          };
        });

      let test = this.currentEles.polygons.find((j) =>
        j.id.toString().indexOf('test') > -1
      );
      this.currentEles.polygons = this.itemList
        .filter(i => [2, 3].includes(i.itemType))
        .filter(i => i.showCheck)
        .map(i => {
          const url = this.currentEles.polygons.find((j) =>
            [i.itemId, ...arr].includes(j.id)
          )?.url;

          if (i.itemType == 2) {
            let data = JSON.parse(i.geometryInfo).coordinates;
            getMap(data, i.itemId);

            return {
              ...i,
              url,
              tupuUrl: url,
              id: i.itemId,
              data: data,
            };
          } else {
            return {
              ...i,
              url,
              tupuUrl: url,
              id: i.itemId,
              data:
                parseGeoInfoToMapData(i.geometryInfo)?.[0].map((it) => {
                  return {
                    ...it,
                    id: i.itemId,
                  };
                }) || [],
            };
          }
        });
        if(test){
          this.currentEles.polygons.push(test);
        }
      this.$nextTick(() => {
        this.updateMap();
        this.$refs.l.drawWmsLayer(this.itemList);
      });
    },

    async getPlanList(options = {}) {
      const { isNewWindFarm = false } = options;

      const [err, result] = await to(
        refreshWindfarmPlanList({
          projectId: this.$route.query.projectId,
        })
      );

      if (!err && result.code == 0) {
        this.planList = (result.data?.planList || []).map((v) => {
          return {
            inputName: v.planName,
            ...v,
            edit: false,
            showCheck: false
          };
        });
        this.getActivePlanByQuery(options);
      }
    },
    async getWindfarmExclusiveList() {
      const [err, result] = await to(
        getWindfarmExclusive({
          projectId: this.$route.query.projectId,
        })
      );

      if (!err && result.code == 0) {
        this.windfarmExclusiveList =
          result.data?.exclusiveList?.map?.(i => {
            let data = JSON.parse(i.geometryInfo).coordinates;
            getMap(data, i.exclusiveId);

            return {
              ...i,
              id: i.exclusiveId,
              data: data,
              showCheck: true,
              edit: false,
              inputName: i.exclusiveName,
            };
          }) || [];
      }
    },

    async updateExclusiveArea() {
      const list = this.windfarmExclusiveList.filter(i => i.showCheck);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'exclusive',
        data: list.map(i => i.data),
      });
    },

    deletePlanList(plan) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, result] = await to(
          deleteWindfarmPlan({ planIds: plan.planId })
        );
        if (!err && result.code == 0) {
          this.getPlanList();
          this.curPlanItem = {};
          this.curPlan = {};
          this.$message.success(result.message);

          this.$router.push({
            name: 'project-list',
            query: {
              projectId: this.$route.query.projectId,
              projectName: this.$route.query.projectName,
            },
          });
        } else {
          this.$message({
            type: 'error',
            message: '删除失败!',
          });
        }
      });
    },
    deleteWindItem(item, noConfirm = false) {
      const fn = async () => {
        const [err, result] = await to(deleteWindItem({ itemId: item.itemId }));
        if (!err && result.code == 0) {
          await this.getWindResource();
          this.updateResource();
          this.$message.success(result.message);
        } else {
          this.$message({
            type: 'error',
            message: '删除失败!',
          });
        }
      };

      if (noConfirm) {
        return fn();
      }

      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await fn();
      });
    },
    deleteExclusiveItem(item) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, result] = await to(
          deleteWindfarmExclusive({ exclusiveId: item.exclusiveId })
        );
        if (!err && result.code == 0) {
          this.getWindfarmExclusiveList();
          this.$message.success(result.message);
        } else {
          this.$message({
            type: 'error',
            message: '删除失败!',
          });
        }
      });
    },

    handleAddressSearch(payload) {
      const { name, address } = payload;
      if (this.$route.name === 'project-list') {
        const obj = {
          type: 'Point',
          coordinates: [address.lng, address.lat],
        };
        const str = JSON.stringify(obj);

        const params = {
          itemName: name,
          itemType: '1',
          geometryInfo: str,
          projectId: '0',
          data: address,
        };
        this.createItems(params);
      } else {
        const { address = {} } = payload;
        this.createPointItem(address, true);
      }
    },

    async queryBoundaryByregionId(id, transe = false) {
      return this.$fetch('/windfarm/project/getRegionBoundary', {
        showError: true,
        params: {
          // 拿默认的
          regionId: id,
        },
      }).then((res) => {
        let id = this.createRandomId();
        const { data = {} } = res || [];
        const { geometryInfo = { coordinates: '' } } = data;

        let result = JSON.parse(geometryInfo).coordinates || [];
        if (!transe) {
          return result;
        } else {
          const fuzhi = cloneDeep(result);
          getMap(fuzhi, id);
          return { _polyline: fuzhi, id, geometryInfo };
        }
      });
    },

    async handleCreateArea(payload) {
      const { name, code } = payload;

      const { _polyline, id, geometryInfo } =
        await this.queryBoundaryByregionId(code, true);

      // console.log('_polyline', _polyline);
      const polyline = flattenDepth(_polyline, 4);
      // let area = 0;
      // if(_polyline.length > 0){
      //   for(let i=0;i<_polyline.length;i++){
      //     let a = calcAreaByData(_polyline[i], true);
      //     area = area + a;
      //   }
      // }
      const params = {
        isTemp: true,
        projectId: this.$route.query.projectId,
        itemName: name,
        adcode: code,
        data: _polyline,
        extra: _polyline,
        geometryInfo: geometryInfo,
        itemType: '2',
        area: calcAreaByData(polyline, true)
      };

      this.citySearchVisible = false;

      // this.postCreateItemApi(params).then(() => {
      //   this.getWindResource();
      // });

      this.createItems(params, id);

      this.$refs.l.defaultWmsLayer(code);
      // if (this.$route.name === 'project-list') {
      //   const { name, code } = payload;
      //   const {
      //     _polyline,
      //     id,
      //     geometryInfo
      //   } = await this.queryBoundaryByregionId(code, true);
      //   const polyline = flattenDepth(_polyline, 4);

      //   // const geometryInfo = parseMapDataToGeoInfo(polyline, 'Polygon', false);

      //   const params = {
      //     projectId: '0',
      //     itemName: name,
      //     adcode: code,
      //     data: _polyline,
      //     extra: polyline,
      //     geometryInfo: geometryInfo,
      //     itemType: '4',
      //     area: calcAreaByData(polyline, false)
      //   };

      //   this.createItems(params, id);
      // } else {
      //   const { name, code } = payload;
      //   const {
      //     _polyline,
      //     regionBoundary
      //   } = await this.queryBoundaryByregionId(code, true);

      //   const polyline = flattenDepth(_polyline, 4);

      //   this.createPolygonItem(polyline, 4, code, {
      //     geometryInfo: regionBoundary,
      //     name: name,
      //     needTrans: false,
      //     _polyline,
      //     setView: true
      //   });
      // }
    },
    handleCreatePoint(data) {
      if (this.$route.name === 'project-list') {
        const obj = {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        };
        const str = JSON.stringify(obj);

        const params = {
          itemName: '临时点',
          itemType: '1',
          geometryInfo: str,
          projectId: '0',
          data: data,
        };
        this.createItems(params);
      } else {
        this.createPointItem(data, true);
      }
    },

    updateMapItemsIMG(payload) {
      const { id, url,isTemp } = payload;

      const item = this.currentEles.polygons.find(i => i.itemId === id);

      if (item) {
        item.url = url;
        item.tupuUrl = url;
        this.updateMap();
        // if(isTemp){
        //   let maxLat = -1000;
        //   let maxLng = -1000;
        //   let minLat = 1000;
        //   let minLng = 1000;
        //
        //   const handleData =
        //     item.itemType == '2' ? flattenDepth(item.data, 4) : item.data;
        //
        //   handleData.forEach((it) => {
        //     const { lat, lng } = it;
        //
        //     if (maxLat < lat) {
        //       maxLat = lat;
        //     }
        //
        //     if (minLat > lat) {
        //       minLat = lat;
        //     }
        //
        //     if (maxLng < lng) {
        //       maxLng = lng;
        //     }
        //
        //     if (minLng > lng) {
        //       minLng = lng;
        //     }
        //   });
        //
        //   const data = [
        //     {
        //       lat: maxLat,
        //       lng: minLng,
        //     },
        //     {
        //       lat: maxLat,
        //       lng: maxLng,
        //     },
        //     {
        //       lat: minLat,
        //       lng: maxLng,
        //     },
        //     {
        //       lat: minLat,
        //       lng: minLng,
        //     },
        //   ];
        //
        //   // this.$refs.l.defaultImageLayer({
        //   //   latlngs: data,
        //   //   url: item.url,
        //   // });
        // }else{
        //   this.updateMap();
        // }

      }
    },
    handleDelFaceItemClick(id) {
      this.$confirm('是否删除该要素', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const index = this.currentEles.polygons.findIndex(i => i.id == id);
        this.currentEles.polygons.splice(index, 1);
        this.updateMap();
      });
    },
    handleMapInput(e) {
      console.log(e);
    },
    getMapInstance(cb) {
      cb(this.$refs.l);
    },

    showFengjiDetail(id,edit = false) {
      const fan = this.turbineList.find((v) => v.turbineId === id);
      this.curFan = {
        synthesizeLoss: this.curPlanItem?.synthesizeLoss,
        ...fan,
      };
      this.fanPanelVisible = true;
      //this.updateTurbine(this.curPlanItem.planId);
      this.editTurbine(this.curFan,edit);
      this.activeSpecialPointItem = null;
      this.editTower(this.curTower,false);
    },

    showTower(data,edit = false) {
      this.curTower = this.towerList.find((v) => v.towerId === data.id);

      this.activeSpecialPointItem = {
        id: this.createRandomId(),
        data,
        lat: data.lat,
        lon: data.lng||data.lon,
        datasetCode: '',
        datasetHeight: '',
      };
      this.editTower(this.curTower,edit);
      this.fanPanelVisible = false;
      this.editTurbine(this.curFan,false);
    },

    handleElementClick(e) {
      let { type, data } = e;

      if (type === 'markers') {
        data = data || {};

        const { type } = data;

        if (type === 'project-list-point') {
          const pointsList = this.currentEles.points || [];
          const item = pointsList.find(i => i.id == data.id);
          this.currentItem = item;
          this.showItemById(data.id, '1');
        }

        if (type === 'turList') {
          this.showFengjiDetail(data.id);
        }

        if (type === 'tower') {
          this.showTower(data);
        }
      }

      if (type === 'polygons') {
        const type = findDeepByAttr(data, 'type');
        const id = findDeepByAttr(data, 'id');
        if(type == 'exclusive'){
          this.curWindExclusiveItem = {exclusiveId:id}
          return;
        }

        const polys = this.currentEles.polygons || [];
        const item = polys.find(i => i.id == id);
        if(item){
          this.currentItem = item
        }

        if (type === 'faceItems' || type === 'faceItems_xingzheng') {
          return this.$bus.$emit('res-face-click', data);
        }

        if (type === 'windscope') {
          return this.$bus.$emit('wind-scope-click', data);
        }

        if (type === 'project-list-poly_xingzheng') {
          this.showItemById(id, '2');
        }

        if (type === 'project-list-poly') {
          this.showItemById(id, '3');
        }
      }

      if (type === 'polylines') {
        const myType = findDeepByAttr(data, 'type');

        if (myType === 'roadlist') {
          this.$bus.$emit('road-line-click', data);
        } else if (myType === 'wirelist') {
          this.$bus.$emit('wire-line-click', data);
        }
      }
    },
    downloadTemplate() {
      window.open(
        `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=windfarm.xlsx`,
        '_parent'
      );
    },
    fengjiClick(data, map) {
      this.$bus.$emit('clickFengji', data, map);
    },
    gantaClick(data, map) {
      this.$bus.$emit('clickGanta', data, map);
    },
    handleUploadChange(file, fileList) {
      if (!fileList.length) {
        this.file = null;
        this.uploadForm.uploadFileName = '';
      } else {
        this.file = file;
        this.uploadForm.uploadFileName = file?.name;
        this.fileList = [file];
      }

      // this.fileList = fileList;
      // this.file = null;
      // this.uploadForm.uploadFileName = '';
    },
    handleTriImport() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append('file', this.file?.raw);
          formData.append('apiKey', getToken());

          this.$fetch({
            method: 'POST',
            url: '/windfarm/windfarm/uploadFileCheck',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            noJudge: true,
          }).then((res) => {
            const { code, message } = res.data;

            if (code == 0) {
              this.aswitch = loadingMask({ mask: true });

              this.$refs.upload.submit();
            }

            if (code == 2) {
              this.$confirm(message, '提醒', {
                confirmButtonText: '继续上传',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                this.aswitch = loadingMask({ mask: true });
                this.$refs.upload.submit();
              });
            }

            if (code == 1) {
              return this.$message.error(message);
            }
          });
        }
      });
    },
    uploadErrorCb() {
      this.file = null;
      this.showImportWindFarmDialog = false;
      this.$refs.form.resetFields();

      this.aswitch && this.aswitch.close();
    },
    uploadSuccessCb(res) {
      const { code, message, data } = res;
      this.aswitch && this.aswitch.close();
      this.fileList = [];
      this.uploadForm.uploadFileName = '';
      this.uploadForm.windfarmName = '';

      this.$refs.form.resetFields();
      this.file = '';

      this.$refs.upload.clearFiles();
      if (code === 0) {
        const { windfarm = {} } = data;

        this.showImportWindFarmDialog = false;
        this.$message({
          message: message,
          type: 'success',
        });
        this.uploadForm.uploadFileName = '';

        // 成功后做的事情
        this.$bus.$emit('updateWindFarmAndItems', {
          type: 'windFarm',
          data: windfarm,
        });
      } else {
        this.$message({
          message: message,
          type: 'error',
        });
      }
    },
    layerChange(layers) {
      this.layers = layers;
    },
    handleImportFile() {
      if (this.$route.name === 'project-list') {
        return this.$message.warning('未进入工程暂不可用');
      }

      this.showImportWindFarmDialog = true;
    },
    handleToolClick(type, value) {
      if (type === 'lanLon') {
        this.lanlonSearchVisible = !this.lanlonSearchVisible;

        this.citySearchVisible = false;
      }
      if (type === 'city') {
        this.citySearchVisible = !this.citySearchVisible;
        if (!this.citySearchVisible) {
          this.activeFaceItem = null;
        }
        this.lanlonSearchVisible = false;
      }

      // 如果是敏感区手绘
      if (type === 'exclusive') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['exclusive'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_DRAWCOLOR', 'orange');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'exclusive',
          value: !status,
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawPolygon',
          value: !status,
        });
      }

      if (type === 'point') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['marker'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'marker',
          value: !status,
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawMarker',
          value: !status,
        });
      }

      if (type === 'polygon') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['polygon'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_DRAWCOLOR', 'white');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'polygon',
          value: !status,
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawPolygon',
          value: !status,
        });
      }

      if (type === 'rect') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['rectangle'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'rectangle',
          value: !status,
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawRectangle',
          value: !status,
        });
      }
    },
    handleWindFarmBoundary(c) {
      if (c === 'drawWindFarm') {
        this.handleNewWindFarm(c);
      } else if (c === 'importKMZ') {
        this.boundaryImportVisible = true;
      } else if (c === 'exportKMZ') {
        this.exportKMZ();
      }
    },
    handleNewWindFarm(value, repeat) {
      // if (this.$route.name !== 'project-list')
      //   return this.$message.warning('未进入工程暂不可用');
      const fn = (v) => {
        let status;

        if (v !== undefined) {
          status = !v;
        } else {
          status = this.toolUIStatus['newFarm'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_DRAWCOLOR', '#478beb');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'newFarm',
          value: !status,
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawPolygon',
          value: !status,
        });
      };

      // 如果已经出现了风场边界

      if (this.showWindfarm && !repeat) {
        this.$confirm(
          '重绘风场边界后，原风场所有方案的相关设计结果将被清除，请确认是否要重绘边界',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          // 清除风场边界
          this.updateWindFarm([]);
          this.$nextTick(() => {
            fn(value);
          });
        });
      } else {
        fn(value);
        this.getPlanList({
          isNewWindFarm: true,
        });
      }
    },

    exportKMZ() {
      const apiKey = getToken();
      // window.open(
      //   `${process.env.VUE_APP_API_HOST}/windfarm/project/downloadWindfarmKmzFile?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`,
      //   '_parent'
      // );

      const loading = this.$loading({
          text: '报告正在生成中，请稍后...',
          spinner: 'el-icon-loading',
        });

        this.$fetch(`/windfarm/project/downloadWindfarmKmzFile?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`, {
          method: 'post',
          showError: true,
          // showLoading: {
          //   mask: true,
          //   loadingContent: '正在下载请稍后'
          // },
          noJudge: true,
          responseType: 'blob',
        })
          .then(res => {
            const blob = new Blob([res.data]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            let docName = this.$route.query.projectName + "-风场边界.kmz";
            link.download = docName; //文件名称
            link.click();
            loading.close();
          })
          .catch(() => {});

    },
    createRandomId() {
      return 'test' + Math.ceil(Math.random() * 1000000);
    },

    createItems(params, getId = '') {
      let id = getId;
      if (!id) {
        id = this.createRandomId();
      }

      const {
        itemType = '',
        data,
        itemName,
        area,
        geometryInfo,
        adcode,
        extra,
        isTemp,
      } = params;

      if (itemType == '1') {
        const item = {
          isTemp,
          data,
          itemName,
          lon: data.lng,
          lat: data.lat,
          id,
          itemType,
          itemId: id,
          datasetCode: '',
          datasetHeight: '',
        }
        this.currentEles.points.push(item);
        this.currentItem = item;
      } else if (itemType == '2') {
        const item = {
          isTemp,
          data: data,
          area,
          itemName,
          itemType,
          id,
          itemId: id,
          url: '',
          extra,
          adcode,
          code: adcode,
          geometryInfo,
          datasetCode: '',
          datasetHeight: '',
          elementCode: 'wspd',
          legendRange: '2',
          tupuUrl: '',
        }
        this.currentEles.polygons.push(item);
        this.currentItem = item;
      } else {
        const item = {
          extra: data.map(i => ({ id, ...i })),
          isTemp,
          data: data.map(i => ({ id, ...i })),
          area,
          itemName,
          itemType,
          id,
          itemId: id,
          url: '',
          code: null,
          geometryInfo:
            geometryInfo || parseMapDataToGeoInfo(data, 'Polygon', true),
          datasetCode: '',
          datasetHeight: '',
          elementCode: 'wspd',
          legendRange: '2',
          tupuUrl: '',
        }
        this.currentEles.polygons.push(item);
        this.currentItem = item;
        // this.windExclusiveModalVisible = true;
        // this.createForm.geometryInfo = geometryInfo;
      }

      this.$nextTick(() => {
        this.updateMap(() => {
          this.showItemById(id, itemType, true);
        });
      });
    },

    showItemById(id, type, setView, zoom) {
      if (type == '1') {
        const pointsList = this.currentEles.points || [];
        const item = pointsList.find(i => i.id == id);
        const data = item.data;

        if (setView) {
          this.$refs.l.map.setView(
            {
              lat: data.lat,
              lon: data.lng || data.lon,
            },
            zoom
          );
        }

        const { data: aData } = item;
        const { lat, lng } = aData;
        if (item.itemId == this.currentItem.itemId) {
          this.activePointItem = item;
          this.activeFaceItem = null;
        }
        this.pointLocation = {
          lat: toFixed(lat, 6),
          lon: toFixed(lng, 6),
        };
      } else if(!this.toolUIStatus['fengji']){
        const polys = this.currentEles.polygons || [];

        const item = polys.find(i => i.id == id);

        let data = flattenDepth(item.data, 4);
        if (item.itemId == this.currentItem.itemId) {
          this.activePointItem = null;
          this.activeFaceItem = item;
        }

        let aver1 = data.map(i => i.lat);
        let aver2 = data.map(i => i.lng);

        const loc = {
          lat: calcAverage(aver1),
          lng: calcAverage(aver2),
        };

        if (setView) {
          this.$refs.l.map.setView(loc, zoom);
        }
      }
    },

    updateMap(cb) {
      // this.$store.commit('WindFarm/CLEAN_MAP');
      const markers = this.currentEles.points.map(i => {
        return {
          ...i.data,
          id: i.id,
          iconSize: [15, 20],
          iconAnchor: [7.5, 20],
          icon: require('@/components/leaflet-map/marker-icon.png'),
          // icon: pointIcon
        };
      });

      const polygons = this.currentEles.polygons
        .filter(i => i.itemType == '3')
        .map(i => {
          return [...i.data];
        });

      const xingzheng = this.currentEles.polygons
        .filter(i => i.itemType == '2')
        .map(i => {
          return [...i.data];
        });

      const imgs = this.currentEles.polygons
        .filter(i => i.url)
        .map(i => {
          let maxLat = -1000;
          let maxLng = -1000;
          let minLat = 1000;
          let minLng = 1000;

          const handleData =
            i.itemType == '2' ? flattenDepth(i.data, 4) : i.data;

          handleData.forEach((item) => {
            const { lat, lng } = item;

            if (maxLat < lat) {
              maxLat = lat;
            }

            if (minLat > lat) {
              minLat = lat;
            }

            if (maxLng < lng) {
              maxLng = lng;
            }

            if (minLng > lng) {
              minLng = lng;
            }
          });

          const data = [
            {
              lat: maxLat,
              lng: minLng,
            },
            {
              lat: maxLat,
              lng: maxLng,
            },
            {
              lat: minLat,
              lng: maxLng,
            },
            {
              lat: minLat,
              lng: minLng,
            },
          ];

          return {
            latlngs: data,
            url: i.url,
          };
        });

      if (xingzheng) {
        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'project-list-poly_xingzheng',
          data: xingzheng,
        });
      }

      if (!xingzheng.length) {
        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'project-list-poly_xingzheng',
          data: [],
        });
      }

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'project-list-poly',
        data: polygons,
      });

      this.$store.commit('WindFarm/SET_RAW_MARKERS', {
        type: 'project-list-point',
        data: markers,
      });

      this.$store.commit('WindFarm/SET_IMAGE', imgs);

      this.$nextTick(() => {
        cb && cb();
      });
    },

    createInProjectList(e) {
      const { type, data } = e;

      if (type === 'markers') {
        const obj = {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        };
        const str = JSON.stringify(obj);
        const params = {
          itemName: '临时点',
          itemType: '1',
          geometryInfo: str,
          data,
          projectId: '0',
        };

        this.createItems(params);
      }

      if (type === 'polygons') {
        const area = calcAreaByData(data, true);
        if (area < 0.1) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能小于0.1平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能大于' + FACEITEMAREALIMIT + '平方公里');
        }

        const str = parseMapDataToGeoInfo(data, 'Polygon', true);
        const params = {
          itemName: '临时区域',
          itemType: '3',
          geometryInfo: str,
          data,
          projectId: '0',
          area: area,
        };
        this.createItems(params);
      }

      if (type === 'rectangles') {
        const area = calcAreaByData(data, true);

        if (area < 0.1) {
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能小于0.1平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能大于' + FACEITEMAREALIMIT + '平方公里');
        }

        const str = parseMapDataToGeoInfo(data, 'Polygon', true);

        const params = {
          itemName: '临时区域',
          itemType: '2',
          geometryInfo: str,
          data,
          projectId: '0',
          area: area,
        };
        this.createItems(params);
      }

      // 清除按钮状态
      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
    },

    createEleFn(e) {
      const { type, data } = e;

      //检查面积大小
      let area = null;
      if(type === "polygons"){
        area = calcAreaByData(data, true);
        if (area < 0.1) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能小于0.1平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能大于' + FACEITEMAREALIMIT + '平方公里');
        }
      }

      // if (this.$route.name === 'project-list') {
      //   this.createInProjectList(e);
      //   return;
      // }

      const newWindFarmstatus = this.toolUIStatus['newFarm'];
      const pointItemStatus = this.toolUIStatus['marker'];
      const polygonItemStatus = this.toolUIStatus['polygon'];
      const rectItemStatus = this.toolUIStatus['rectangle'];
      const shengyazhanAdd = this.toolUIStatus['shengyazhanAdd'];
      const limitAdd = this.toolUIStatus['limitAdd'];
      const entrance = this.toolUIStatus['entrance'];
      const keyPoint = this.toolUIStatus['keyPoint'];
      const lxLimitAdd = this.toolUIStatus['lxLimitAdd'];
      const fengjiPoint = this.toolUIStatus['fengji'];
      const exclusive = this.toolUIStatus['exclusive'];

      // 走创建风场逻辑
      if (newWindFarmstatus && type === 'polygons') {
        // 弹窗
        this.createWindFarmFn(data);
      }

      if (pointItemStatus && type === 'markers') {
        this.createItems({
          data,
          itemName: '',
          lon: data.lng,
          lat: data.lat,
          itemType: 1,
          datasetCode: '',
          datasetHeight: '',
          isTemp: true,
        });

        this.handleToolClick('point', false);
      }

      if (polygonItemStatus && type === 'polygons') {
        this.createItems({
          data,
          area,
          itemName: '',
          itemType: 3,
          datasetCode: '',
          datasetHeight: '',
          isTemp: true,
        });
      }

      if (rectItemStatus && type === 'rectangles') {
        this.createPolygonItem(data, 2);
      }

      if (shengyazhanAdd && type === 'markers') {
        this.$bus.$emit('createShengyazhan', data);
      }

      if (limitAdd && type === 'polygons') {
        this.$bus.$emit('createLimitAdd', data);
      }

      if (entrance && type === 'markers') {
        this.$bus.$emit('createEntrancePoint', data);
      }

      if (keyPoint && type === 'markers') {
        this.$bus.$emit('createKeypoint', data);
      }

      if (lxLimitAdd && type === 'polygons') {
        this.$bus.$emit('createLXLimitAdd', data);
      }

      if (fengjiPoint && type === 'markers') {
        this.$bus.$emit('createfengji', data);
      }

      if (exclusive && type === 'polygons') {
        this.createForm.geometryInfo = parseMapDataToGeoInfo(data, 'Polygon');
        this.curWindExclusiveItem = {};
        this.windExclusiveModalVisible = true;
      }
      //console.log(type);
    },

    createPolygonItem(
      data,
      itemType,
      adcode = '',
      extra = {
        name: '',
        geometryInfo: '',
        area: '',
        setView: false,
        id: '',
      }
    ) {
      let area = 0;

      if (data !== null) {
        if (!adcode) {
          data = flattenDepth(data, 4);
          area = calcAreaByData(data, true);
          if (area < 0.1) {
            if (itemType == 3) {
              this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
            }

            // if (itemType == 2) {
            //   this.$store.commit('WindFarm/POP_MAPDATA_RECT');
            // }

            this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

            return this.$message.warning('面积不能小于0.1平方公里');
          }
          if (area > FACEITEMAREALIMIT) {
            if (itemType == 3) {
              this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
            }

            // if (itemType == 2) {
            //   this.$store.commit('WindFarm/POP_MAPDATA_RECT');
            // }
            this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

            return this.$message.warning('区域面积不能大于' + FACEITEMAREALIMIT + '平方公里');
          }
        }
      }

      const params = {
        itemType: itemType, // 多边形
        projectId: this.$route.query.projectId,
        itemName: '临时区域',
        ischecked: 1,
        area,
      };

      if (itemType == 2) {
        params.adcode = adcode;
        params.itemName = extra.name;
        params.geometryInfo = extra.geometryInfo;
        params.projectId = this.$route.query.projectId;
      } else {
        params.geometryInfo = parseMapDataToGeoInfo(
          data,
          'Polygon',
          itemType != 2
        );
      }

      this.postCreateItemApi(params)
        .then(async (res) => {
          const { data = {} } = res;
          const { projectItem = {} } = data;

          // if (itemType == 2) {
          //   this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          // }

          if (itemType == 3) {
            this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          }

          // this.handleToolClick('point', false);
          await this.getWindResource();
          // this.currentItem = projectItem;
          this.$refs.l.defaultWmsLayer(null);
          this.$refs.l.defaultImageLayer(null);
          const index = this.currentEles.polygons.findIndex(i => i.id == extra.id);
          this.currentEles.polygons.splice(index, 1);
          this.updateResource();
          this.handleItemPointClick(projectItem, 11);

          if (this.activeFaceItem) {
            this.activeFaceItem.id = projectItem.itemId;
            this.activeFaceItem.itemId = projectItem.itemId;
          }
        })
        .catch(() => {
          // if (itemType == 2) {
          //   this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          // }
          // if (itemType == 3) {
          //   this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          // }
        });
    },
    createPointItem(data) {
      const obj = {
        type: 'Point',
        coordinates: [data.lon || data.lng, data.lat],
      };
      const str = JSON.stringify(obj);
      const params = {
        itemName: '临时点',
        itemType: '1',
        projectId: this.$route.query.projectId,
        geometryInfo: str,
      };
      const temp_id = data.id;
      this.postCreateItemApi(params)
        .then(async (res) => {
          const { data = {} } = res;
          const { projectItem = {} } = data;

          this.$store.commit('WindFarm/POP_MAP_POINT');
          this.handleToolClick('point', false);

          await this.getWindResource();

          const index = this.currentEles.points.findIndex(i => i.id == temp_id);
          this.currentEles.points.splice(index, 1);
          this.updateResource();
          this.handleItemPointClick(projectItem, 11);

          if (this.activePointItem) {
            this.activePointItem.itemId = projectItem.itemId;
            this.activePointItem.id = projectItem.id;
          }

          // this.$bus.$emit('updateWindFarmAndItems', {
          //   data: projectItem,
          //   type: 'point',
          //   setView
          // });
        })
        .catch(() => {
          this.$store.commit('WindFarm/POP_MAP_POINT');
        });
    },
    createWindFarmFn(data) {
      const maxLats = Math.max(...data.map(i => i.lat));
      const minLats = Math.min(...data.map(i => i.lat));
      const minLngs = Math.min(...data.map(i => i.lng));
      const maxLngs = Math.max(...data.map(i => i.lng));

      if (maxLats > 90 || minLats < -90) {
        this.$message.warning('风场范围的纬度应在-90°至90°之间');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      if (maxLngs > 180 || minLngs < -180) {
        this.$message.warning('风场范围的经度应在-180°至180°之间');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      const area = calcAreaByData(data, true);

      if (area > WINDFARMAREALIMIT) {
        this.$message.warning('面积不能大于5000平方公里');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      if (area < 0.1) {
        this.$message.warning('面积不能小于0.1平方公里');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      const newData = data.concat([data[0]]);
      const str = parseMapDataToGeoInfo(newData, 'Polygon');

      createStation({
        farmBoundary: str,
        projectId: this.$route.query.projectId
      }).then(async res => {
        this.showWindfarm = true;

        const { projectInfo } = res.data;
        const { planList = [] } = projectInfo;

        const firstItem = planList?.[0];
        // firstItem.showCheck = true;
        if (firstItem) {
          this.handlePlanCheckChange(firstItem);
        }

        setTimeout(() => {
          this.queryProjectDetail();
        }, 1000);
        this.handleNewWindFarm(false, true);
        await this.getWindResource();
        this.updateResource();
      });

      // 如果用户没有方案，则弹出创建方案弹窗
      // 否则直接调用接口

      // this.createForm.geometryInfo = str;
      // this.windExclusiveModalVisible = true;
    },
    postCreateItemApi(params) {
      return this.$postForm('/windfarm/project/createItem', {
        showSuccess: true,
        showError: true,
        data: {
          apiKey: getToken(),
          ...params,
        },
      });
    },

    getStyle(type, data) {
      if (this.windFarmIsEdit && type === 'polygons') {
        const type = findDeepAttr(data) || '';
        if (!type) {
          return { color: '#478beb', fillOpacity: 0 };
        }
      }

      if (type === 'polygons') {
        // const isClickActive = data && data[0] && data[0].isClickActive;
        const type = findDeepAttr(data) || '';

        if (type === 'windFarm') {
          return { color: 'white', fillOpacity: 0, weight: 3};
        } else if (type === 'deploy-condition') {
          return { color: 'pink', fillOpacity: 0 };
        } else if (type === 'faceItems') {
          return { color: '#89c6ff', fillOpacity: 0, weight: 2};
        } else if (
          type === 'project-list-poly_xingzheng' ||
          type === 'project-list-poly'
        ) {
          return { color: '#89c6ff', fillOpacity: 0, weight: 2};
        } else if (type === 'lx-result-area') {
          return {
            color: '#85ffe4',
            fillOpacity: 0.3,
            weight: 1
          };
        } else if (type === 'lx-limit-area') {
          return {
            color: 'pink',
            fillOpacity: 0,
          };
        } else if (type === 'exclusive' || this.toolUIStatus.exclusive) {
          return {
            color: 'red',
            fillColor: 'pink',
            fillOpacity: 0.2,
            weight: 1
          };
        } else {
          return { color: '#478beb', fillOpacity: 0 };
        }
      }

      if (type === 'polylines') {
        const itemType = findDeepAttr(data) || '';

        if (itemType === 'roadlist') {
          return {
            color: '#fff',
            fillOpacity: 0,
          };
        }

        if (itemType === 'wirelist') {
          const myIndex = this.windfarmWireList.findIndex(
            (wire) => wire.wireId === findDeepAttr(data, 'wireId')
          );

          return {
            color: COLORS[myIndex % COLORS.length],
            fillOpacity: 0,
            width: '10',
          };
        }
      }

      function findDeepAttr(data, attr = 'type') {
        if (!data) return '';

        if (Array.isArray(data)) {
          return findDeepAttr(data[0], attr);
        } else if (isObject(data)) {
          return data[attr] || '';
        }
      }
    },

    handleTriggerTools() {
      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
    },
    handleSavePointClick(item) {
      this.$bus.$emit('save-point-item-click', item);
    },
    handleSavePointItemClick(item) {
      this.createPointItem(item, true);
    },

    async updateWindFarmReducer(payload) {
      const { data, type, setView } = payload;
      console.log(data, setView);
      if (type === 'point' || type === 'poly') {
        await this.getWindResource();
        this.updateResource([data?.itemId]);
      }

      // if (type === 'windFarm') {
      // }

      // const { data, type, setView } = payload;
      // if (type === 'point' || type === 'poly') {
      //   this.createElementByType(data, type, setView);
      // }

      // if (type === 'windFarm') {
      //   if (this.farmList[0]) {
      //     this.farmList[0].isShow = false;
      //   }

      //   this.queryWindfarmAndItemList(() => {}, {
      //     windfarmId: data.windfarmId
      //   });
      // }
    },

    setMapView(latlng, zoom = '') {
      this.$bus.$emit('getMapInstance', (instance) => {
        instance.map.setView(
          {
            ...latlng,
          },
          zoom
        );
      });
    },

    resetActiveItem() {
      this.$store.commit('WindFarm/SET_POINT_ITEM');
      this.activePointItem = null;
      this.activeFaceItem = null;
    },
    clearItem() {
      if (this.$route.query.planId) {
        this.$router.replace({
          name: 'project-list',
          query: {
            planId: this.$route.query.planId,
            projectId: this.$route.query.projectId,
            projectName: this.$route.query.projectName,
          },
        });
      }
    },
    async handleItemPointClick1(item,zoom) {
      this.currentItem = item;
      if (item?.showCheck) {
        this.showItemById(item.itemId, item.itemType, false, zoom);
        //资源定位
        if(item.itemType == 1){
          let data = item;
          this.$refs.l.map.setView(
            {
              lat: data.lat,
              lon: data.lng || data.lon,
            },
            zoom
          );
        }else{
          const polys = this.currentEles.polygons || [];

          const it = polys.find(i => i.id == item.itemId);
          let data = flattenDepth(it.data, 4);

          let aver1 = data.map(i => i.lat);
          let aver2 = data.map(i => i.lng);

          const loc = {
            lat: calcAverage(aver1),
            lng: calcAverage(aver2),
          };

          this.$refs.l.map.setView(loc, zoom);
        }
      }
    },
    async handleItemPointClick(item, zoom) {
      if (!item?.showCheck) {
        item.showCheck = true;
        this.checkboxChange(item);
      }

      /*if (
        this.currentItem?.itemId &&
        item?.itemType == 1 &&
        this.currentItem?.itemId === item?.itemId
      ) {
        this.clearItem();
        this.currentItem = {};
        this.activePointItem = null;
        return;
      }

      if (
        this.currentItem?.itemId &&
        item?.itemType != 1 &&
        this.currentItem?.itemId === item?.itemId
      ) {
        this.clearItem();
        this.currentItem = {};
        this.activeFaceItem = null;
        return;
      }*/

      this.currentItem = item;
      this.showItemById(item.itemId, item.itemType, true, zoom);
      // this.focusToWindFarm();
    },
    handlePlanClick(item){
      // this.planList.map((v) => {
      //   return v.showCheck = false;
      // });

      if(item.showCheck){
        this.focusToWindFarm();
      }else{
        this.handlePlanCheckChange(item);
      }

    },
    handlePlanCheckChange(plan) {
      /*let checkPlanListIds = [];
      this.planList.map((v) => {
        if(v.showCheck){
          checkPlanListIds.push(v.planId);
        }
      });
      this.checkPlanListIds = checkPlanListIds;*/
      // console.log(plan.planId);
      if (plan.showCheck) {
        this.curPlanItem = plan;
        this.$router.push({
          name: 'project-list',
          query: {
            ...this.$route.query,
            planId: plan.planId,
            planName: plan.planName,
            projectId: this.$route.query.projectId,
          },
        });
        this.updateTower(plan.planId);
        this.updateTurbine(plan.planId);
        this.focusToWindFarm();
      } else {
        if (this.curPlanItem?.planId === plan.planId) {
          // this.curPlanItem = {};

        } else {
          this.activeSpecialPointItem = null;
          this.fanPanelVisible = false;
          this.curPlanItem = plan;
          this.$router.push({
            name: 'project-list',
            query: {
              ...this.$route.query,
              planId: plan.planId,
              planName: plan.planName,
              projectId: this.$route.query.projectId,
            },
          });
          this.updateTower(plan.planId);
          this.updateTurbine(plan.planId);
          this.focusToWindFarm();
        }
      }
    },
    checkExclusiveChange(item){
      item.showCheck = !item.showCheck
    },
    handleExclusiveClick(item) {
      this.curWindExclusiveItem = item;
      if (!item.showCheck) {
        item.showCheck = true;
      }
      const data = flattenDepth(item.data);

      let aver1 = data.map(i => i.lat);
      let aver2 = data.map(i => i.lng);

      const loc = {
        lat: calcAverage(aver1),
        lng: calcAverage(aver2),
      };

      this.$refs.l.map.setView(loc);
    },
    handleWindFarmItemClick(item) {
      this.resetActiveItem();
      if (!item) {
        return this.$router.push({
          name: 'project-list',
          query: {
            planId: this.$route.query.planId,
            planName: this.$route.query.planName,
            projectId: this.$route.query.projectId,
            projectName: this.$route.query.projectName,
          },
        });
      }
      if (item) {
        const { routerName, id } = item;
        if (routerName) {
          this.$router.push({
            name: routerName,
            query: {
              planId: id,
              projectId: this.$route.query.projectId,
              projectName: this.$route.query.projectName,
            },
          });
        }
      }
    },
    handleDelPointItemClick(id) {
      this.$confirm('是否删除该点资源', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const index = this.currentEles.points.findIndex(i => i.id == id);
        const item = this.currentEles.points[index];

        if (!item.isTemp) {
          this.deleteWindItem(this.activePointItem, true);
        } else {
          this.updateResource();
        }

        this.currentEles.points.splice(index, 1);
        this.activePointItem = null;
      });
    },

    handleCloseModalClick() {
      // const index = this.currentEles.points.findIndex(
      //   (i) => i.itemId == this.currentItem?.itemId
      // );
      // this.currentEles.points.splice(index, 1);
      this.currentItem = {};
      this.resetActiveItem();
      // this.updateMap();
    },
    // 对比
    contrastClick() {
      if (this.checkPlanListIds.length <= 0) {
        this.$message.warning('请选择对比风场信息');
        return;
      }

      this.$postForm('/windfarm/station/getPlanCompareList', {
        showError: true,
        showSuccess: true,
        data: {
          planIds: this.checkPlanListIds.join(','),
        },
      }).then((res) => {
        console.log(res);
        const { code, message } = res;
        if (code === 1) {
          this.$message.warning(message);
          return;
        } else {
          this.showWindContrastDialog = true;
        }
        const { compareList } = res.data;
        this.tableContrastData = compareList;
        //处理最优方案
        let scheme = this.tableContrastData.reduce((a, b) => {
          return Number(a.cfopcIrr) > Number(b.cfopcIrr) ? a : b;
        });
        this.tableOptimalIndex = this.tableContrastData.findIndex(
          e => e.planId === scheme.planId
        );
        // this.tableContrastData[index].isOptimal=true;
        // console.log(this.tableContrastData);
      });
    },
    exportReport() {
      const apiKey = getToken();

      const loading = this.$loading({
          text: '报告正在生成中，请稍后...',
          spinner: 'el-icon-loading',
        });

        this.$fetch(`/windfarm/stationReport/downReport?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`, {
          method: 'post',
          showError: true,
          // showLoading: {
          //   mask: true,
          //   loadingContent: '正在下载请稍后'
          // },
          noJudge: true,
          responseType: 'blob',
        })
          .then(res => {
            const blob = new Blob([res.data]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            let docName = this.$route.query.projectName + "项目规划报告.doc";
            link.download = docName; //文件名称
            link.click();
            loading.close();
          })
          .catch(() => {});

      //exportDocument(`/windfarm/stationReport/downKYReport?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`,config, docName);

      // window.open(
      //   `${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/stationReport/downKYReport?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`,
      //   '_parent'
      // );
    },
    //面要素导出
    downloadItem(item) {
      const apiKey = getToken();
      window.open(
        `${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/project/plane/getKmzFile?apiKey=${apiKey}&itemId=${item.itemId}`,
        '_parent'
      );
    },
    async confirmChangeItemName(item) {
      const [err, result] = await to(
        updateItemName({
          itemId: item?.itemId,
          itemName: item.inputItemName,
        })
      );
      if (!err && result.code === 0) {
        this.$message.success(result.message || '操作成功');
        item.edit = false;
        this.getWindResource();
      }
    },
    async confirmChangeExclusiveName(item) {
      const [err, result] = await to(
        updateExclusiveName({
          exclusiveName: item.inputName,
          projectId: this.$route.query.projectId,
          avoidDiatance: item.item?.avoidDiatance || 0,
          geometryInfo: item.geometryInfo,
          exclusiveId: item.exclusiveId,
        })
      );
      if (!err && result.code === 0) {
        this.$message.success(result.message || '操作成功');
        item.edit = false;
        this.getWindfarmExclusiveList();
      }
    },
    resultFj(callback) {
      if (this.hasDrag) {
        this.$confirm('当前信息已更新，是否确认保存？', '提示', {
          confirmButtonText: '去保存',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // this.handleFengjiClick(this.hasDrag.data, currentMap);
          })
          .catch(() => {
            this.backToOrigin();
            this.$store.commit('WindFarm/UPDATE_TUILIST');

            this.$bus.$emit('getMapInstance', (instance) => {
              this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                type: 'fengji',
                mapInstance: instance,
                force: true,
              });
            });
          });
        callback && callback(false);
        return;
      }

      if (this.specificDragFlag) {
        this.$store.commit('WindFarm/UPDATE_TUILIST');

        this.$nextTick(() => {
          this.$bus.$emit('getMapInstance', (instance) => {
            this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
              type: 'fengji',
              mapInstance: instance,
            });
          });
        });
      } else {
        this.$store.commit('WindFarm/SET_specificDragFlag', true);
      }

      this.hasDrag = null;
      if (currentP) {
        currentP.clear();
        currentP = null;
      }

      callback && callback(true);
      return true;
    },
    backToOrigin() {
      if (this.specificDragFlag) {
        const { id, data } = this.hasDrag;

        const index = this.turbineList.findIndex(
          (item) => item.turbineId == id
        );
        const newArr = [...this.turbineList];

        newArr[index] = {
          ...newArr[index],
          ...data,
        };

        this.$store.commit('WindFarm/SET_TURLIST', [...newArr]);

        this.$store.commit('WindFarm/UPDATE_TUILIST', {
          activeId: id,
          force: true,
          callback: () => {
            this.$nextTick(() => {
              this.$bus.$emit('getMapInstance', (instance) => {
                this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                  type: 'fengji',
                  mapInstance: instance,
                  filter: () => true,
                  status: true,
                });
              });
            });
          },
        });

        this.$bus.$emit('getMapInstance', (instance) => {
          this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
            type: 'fengji',
            mapInstance: instance,
            filter: () => {
              return true;
            },
            status: true,
          });
        });

        this.hasDrag = null;
        if (currentP) {
          currentP.clear();
          currentP = null;
        }
      }

      if (this.specificChangeFlag) {
        const { id, data } = this.hasDrag;

        const index = this.gantaPointList.findIndex(
          (item) => item.gantaId == id
        );
        const newArr = [...this.gantaPointList];

        newArr[index] = {
          ...newArr[index],
          ...data,
        };

        this.$store.commit('WindFarm/SET_GANTALIST', [...newArr]);
        this.$store.commit('WindFarm/UPDATE_GANTALIST', {
          activeId: id,
          force: true,
          callback: () => {
            this.$nextTick(() => {
              this.$bus.$emit('getMapInstance', (instance) => {
                this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                  type: 'gantaPoint',
                  mapInstance: instance,
                  filter: () => {
                    return true;
                  },
                  status: true,
                });
              });
            });
          },
        });

        this.hasDrag = null;
        if (currentP) {
          currentP.clear();
          currentP = null;
        }
      }
    },
    exportExclusiveKMZ(item) {
      const apiKey = getToken();
      const loading = this.$loading({
          text: '正在导出KMZ，请稍后...',
          spinner: 'el-icon-loading',
        });

        this.$fetch(`/windfarm/project/downloadExclusiveKmzFile?apiKey=${apiKey}&exclusiveId=${item.exclusiveId}`, {
          method: 'post',
          showError: true,
          showLoading: {
            mask: true,
            loadingContent: '正在导出，请稍后'
          },
          noJudge: true,
          responseType: 'blob',
        })
          .then(res => {
            const blob = new Blob([res.data]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            let docName = item.exclusiveName + ".kmz";
            link.download = docName; //文件名称
            link.click();
            loading.close();
          })
          .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.tower-detail-point {
  bottom: -30px;
  height: 250px;
  right: 5px;
  top: auto;
  z-index: 1100;
}
.farm-area-button {
  &.is-active {
    background: #1890ff;
  }
}
.project-item-title {
  display: flex;
}
.daochu {
  cursor: pointer;
}
/deep/ .el-button--text{
  margin-left: 0
}
</style>
